// extracted by mini-css-extract-plugin
export default {"loader-wrapper":"Loader_loader-wrapper__jCjQW","open":"Loader_open__KxfYq","loader-inner":"Loader_loader-inner__imKU+","animationLoader":"Loader_animationLoader__OQKqe"};